// extracted by mini-css-extract-plugin
module.exports = {"liveBtn":"DaoClosedButton_liveBtn__7dERt","viewBtn":"DaoClosedButton_viewBtn__h5HRY"};